module.exports = __webpack_public_path__ + "static/media/player.21a459cd.png";